<template>
  <v-container>
    <v-row v-if="loading" dense>
      <v-col cols="12">
        Laadimine...
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12" v-html="error" />
    </v-row>
    <v-row v-if="reportContent" dense>
      <v-spacer />
      <v-menu offset-y open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :disabled="!formats.length"
            color="secondary"
          >
            Laadi alla
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in formats"
            :key="index"
            @click="downloadReportFile(item)"
          >
            <v-list-item-title>{{
              getFileFormatDisplayName(item)
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
    <v-row v-if="reportContent" dense>
      <v-col id="report-content" cols="12" v-html="reportContent" />
    </v-row>
  </v-container>
</template>

<script>
import download from 'js-file-download'
import { reports } from '@/dataAccess/api'

export default {
  data() {
    return {
      reportCode: decodeURIComponent(this.$route.params.reportCode),
      paramsStr: decodeURIComponent(this.$route.params.paramsStr),
      formats: JSON.parse(decodeURIComponent(this.$route.params.formats)),
      reportContent: '',
      loading: false,
      error: ''
    }
  },
  async mounted() {
    this.error = '' // Removes old errors
    try {
      this.loading = true
      const response = await reports.getReport(this.htmlDownloadURL)
      this.reportContent = response.data
    } catch (e) {
      this.error = e.response.error // TODO check whether it is OK
      if (!this.error) {
        // For instance if 500 happened
        this.error = e.message
      }
    } finally {
      this.loading = false
    }
  },
  computed: {
    htmlDownloadURL() {
      return this.reportCode + this.paramsStr
    }
  },
  methods: {
    getFileFormatDisplayName(format) {
      return fileFormatDisplayNames[format] || format
    },
    getFileDownloadURL(format) {
      return this.reportCode + format + '/' + this.paramsStr
    },
    async downloadReportFile(format) {
      const response = await reports.getFileReport(
        this.getFileDownloadURL(format)
      )
      const filename = response.headers['filename']
      download(response.data, filename)
    }
  }
}

const fileFormatDisplayNames = {
  pdf: 'PDF',
  odt: 'ODT',
  latex: 'LaTeX',
  docx: 'DOCX'
}
</script>

<style>
#report-content {
  width: 100%;
  overflow-x: scroll;
}

#report-content table,
#report-content table th,
#report-content table td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
</style>
